import {
  Button,
  Flex,
  Text,
  Link as ChakraLink,
  HStack,
  Stack,
  Box,
  Separator,
} from "@chakra-ui/react";
import { t } from "i18next";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { appRoutes } from "../../../App";
import { ScreenPolygonMap } from "./ScreenPolygonMap";
import { RouteCheckBox } from "./ScreenRouteCheckBox";
import {
  AppHeader,
  AppHeaderHeight,
} from "../../shared/views/AppHeader/AppHeader";
import { LoadingScreen } from "../../shared/views/LoadingScreen/LoadingScreen";
import { useStores } from "../../shared/stores/RootStore";
import { ArrowBackIcon } from "../../shared/views/icons";

const ScreenPageBase: React.FC = () => {
  const { screenStore, projectStore } = useStores();
  const projectId = useParams().projectId!;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    projectStore.fetchAllProjects().then(() => {
      projectStore.select(projectId);
      setLoading(false);
    });
    // eslint-disable-next-line
  }, []);

  const buttonClick = () => screenStore.resetState();

  return (
    <Flex flexDir="column" maxHeight="100vh" maxWidth="100vw" flexGrow={1}>
      <AppHeader />
      <AppHeaderHeight />
      <Separator />
      {loading && (
        <Box zIndex={3}>
          <LoadingScreen />
        </Box>
      )}
      {screenStore.submitted ? (
        <Flex flexDirection={"column"}>
          <Text m={"1rem"} fontSize={"large"}>
            {t("screen:requestRouteUpload.submitted")}
          </Text>
          <ChakraLink asChild>
            <Link to={appRoutes.project(projectId)}>
              <Button
                onClick={buttonClick}
                m={"1rem"}
                size="sm"
                colorPalette="primary"
                variant="ghost"
                aria-label={"home"}
              >
                <ArrowBackIcon />
                <Text fontSize={"large"}>
                  {t("screen:requestRouteUpload.home")}
                </Text>
              </Button>
            </Link>
          </ChakraLink>
        </Flex>
      ) : (
        <HStack align="stretch" gap={0} flexGrow={1} overflow="auto">
          {screenStore.showCheckList && <RouteCheckBox projectId={projectId} />}
          {projectStore.getSelected() && (
            <Stack flexGrow={1} overflow="auto" gap={0}>
              <ScreenPolygonMap />
            </Stack>
          )}
        </HStack>
      )}
    </Flex>
  );
};

export const ScreenPage = observer(ScreenPageBase);
